<!-- Modal de Configurações -->
<div 
  *ngIf="isOpen" 
  class="settings-backdrop fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 backdrop-blur-sm"
  (click)="onBackdropClick($event)"
>
  <div 
    class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
          <lucide-icon 
            name="settings" 
            class="w-6 h-6 text-blue-600 dark:text-blue-400"
          ></lucide-icon>
        </div>
        <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Configurações</h2>
      </div>
      <button
        (click)="close()"
        class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
        aria-label="Fechar configurações"
      >
        <lucide-icon 
          name="x" 
          class="w-6 h-6 text-gray-500 dark:text-gray-400"
        ></lucide-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="overflow-y-auto flex-1 p-6">
      <!-- Seção de Aparência -->
      <section class="mb-8">
        <div class="flex items-center gap-2 mb-4">
          <lucide-icon 
            name="palette" 
            class="w-5 h-5 text-gray-700 dark:text-gray-300"
          ></lucide-icon>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Aparência</h3>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Escolha o tema que melhor se adapta à sua preferência visual
        </p>
        
        <!-- Opções de Tema -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <button
            *ngFor="let option of themeOptions"
            (click)="selectTheme(option.value)"
            [ngClass]="{
              'ring-2 ring-blue-500 bg-blue-50 dark:bg-blue-900/20': isThemeSelected(option.value)
            }"
            class="flex flex-col items-center p-4 border-2 border-gray-200 dark:border-gray-700 rounded-xl hover:border-blue-400 dark:hover:border-blue-500 transition-all duration-200 group"
          >
            <div 
              [ngClass]="{
                'bg-blue-100 dark:bg-blue-900/50': isThemeSelected(option.value),
                'bg-gray-100 dark:bg-gray-700 group-hover:bg-blue-50 dark:group-hover:bg-blue-900/30': !isThemeSelected(option.value)
              }"
              class="p-3 rounded-full mb-3 transition-colors"
            >
              <lucide-icon 
                [name]="option.icon"
                [ngClass]="{
                  'text-blue-600 dark:text-blue-400': isThemeSelected(option.value),
                  'text-gray-600 dark:text-gray-300': !isThemeSelected(option.value)
                }"
                class="w-6 h-6"
              ></lucide-icon>
            </div>
            <span 
              [ngClass]="{
                'text-blue-600 dark:text-blue-400': isThemeSelected(option.value),
                'text-gray-900 dark:text-white': !isThemeSelected(option.value)
              }"
              class="font-semibold mb-1"
            >
              {{ option.label }}
            </span>
            <span class="text-xs text-center text-gray-600 dark:text-gray-400">
              {{ option.description }}
            </span>
          </button>
        </div>
      </section>

      <!-- Divisor -->
      <div class="border-t border-gray-200 dark:border-gray-700 my-6"></div>

      <!-- Seção de Acessibilidade -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <lucide-icon 
            name="eye" 
            class="w-5 h-5 text-gray-700 dark:text-gray-300"
          ></lucide-icon>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Acessibilidade</h3>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Ajustes de cores para pessoas com daltonismo
        </p>

        <!-- Opções de Daltonismo -->
        <div class="space-y-2">
          <button
            *ngFor="let option of colorBlindOptions"
            (click)="selectColorBlindMode(option.value)"
            [ngClass]="{
              'ring-2 ring-blue-500 bg-blue-50 dark:bg-blue-900/20': isColorBlindModeSelected(option.value)
            }"
            class="w-full flex items-center justify-between p-4 border-2 border-gray-200 dark:border-gray-700 rounded-xl hover:border-blue-400 dark:hover:border-blue-500 transition-all duration-200"
          >
            <div class="flex items-center gap-3">
              <div 
                [ngClass]="{
                  'bg-blue-100 dark:bg-blue-900/50': isColorBlindModeSelected(option.value),
                  'bg-gray-100 dark:bg-gray-700': !isColorBlindModeSelected(option.value)
                }"
                class="p-2 rounded-lg"
              >
                <lucide-icon 
                  [name]="isColorBlindModeSelected(option.value) ? 'check-circle' : 'circle'"
                  [ngClass]="{
                    'text-blue-600 dark:text-blue-400': isColorBlindModeSelected(option.value),
                    'text-gray-400 dark:text-gray-500': !isColorBlindModeSelected(option.value)
                  }"
                  class="w-5 h-5"
                ></lucide-icon>
              </div>
              <div class="text-left">
                <div 
                  [ngClass]="{
                    'text-blue-600 dark:text-blue-400': isColorBlindModeSelected(option.value),
                    'text-gray-900 dark:text-white': !isColorBlindModeSelected(option.value)
                  }"
                  class="font-semibold"
                >
                  {{ option.label }}
                </div>
                <div class="text-sm text-gray-600 dark:text-gray-400">
                  {{ option.description }}
                </div>
              </div>
            </div>
          </button>
        </div>

        <!-- Info sobre acessibilidade -->
        <div class="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <div class="flex gap-3">
            <lucide-icon 
              name="info" 
              class="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5"
            ></lucide-icon>
            <div class="text-sm text-blue-900 dark:text-blue-200">
              <p class="font-medium mb-1">Sobre os filtros de cores</p>
              <p>
                Estes filtros ajudam pessoas com daltonismo a distinguir melhor as cores. 
                Selecione o tipo que melhor se adapta à sua necessidade visual.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Divisor -->
      <div class="border-t border-gray-200 dark:border-gray-700 my-6"></div>

      <!-- Seção Restaurar Padrões -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <lucide-icon 
            name="rotate-ccw" 
            class="w-5 h-5 text-gray-700 dark:text-gray-300"
          ></lucide-icon>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Restaurar Padrões</h3>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Voltar todas as configurações para os valores originais da aplicação
        </p>
        
        <button
          (click)="abrirConfirmacaoRestaurar()"
          class="w-full flex items-center justify-center gap-2 p-4 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 border-2 border-gray-300 dark:border-gray-600 rounded-xl transition-all duration-200 group"
        >
          <lucide-icon 
            name="rotate-ccw" 
            class="w-5 h-5 text-gray-700 dark:text-gray-300 group-hover:rotate-[-360deg] transition-transform duration-500"
          ></lucide-icon>
          <span class="font-semibold text-gray-900 dark:text-white">
            Restaurar Configurações Padrão
          </span>
        </button>

        <div class="mt-3 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg">
          <div class="flex items-start gap-2">
            <lucide-icon 
              name="alert-triangle" 
              class="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5"
            ></lucide-icon>
            <p class="text-xs text-amber-800 dark:text-amber-200">
              Isto irá redefinir o tema para <strong>Claro</strong> e remover todos os filtros de acessibilidade, retornando a aplicação ao seu estado original.
            </p>
          </div>
        </div>
      </section>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
      <button
        (click)="close()"
        class="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-medium rounded-lg transition-colors shadow-sm"
      >
        Concluído
      </button>
    </div>
  </div>
</div>

<!-- Modal de Confirmação para Restaurar Padrões -->
<div 
  *ngIf="showConfirmModal" 
  class="fixed inset-0 bg-black/60 dark:bg-black/80 flex items-center justify-center z-[60] backdrop-blur-sm"
  (click)="fecharConfirmacao()"
>
  <div 
    class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Header com ícone de aviso -->
    <div class="flex items-center gap-3 p-6 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800">
      <div class="p-2 bg-amber-100 dark:bg-amber-900/50 rounded-lg">
        <lucide-icon 
          name="alert-triangle" 
          class="w-6 h-6 text-amber-600 dark:text-amber-400"
        ></lucide-icon>
      </div>
      <h3 class="text-xl font-bold text-gray-900 dark:text-white">Restaurar Padrões</h3>
    </div>

    <!-- Conteúdo -->
    <div class="p-6">
      <p class="text-gray-700 dark:text-gray-300 mb-4">
        Deseja realmente restaurar todas as configurações para os valores padrão?
      </p>
      <div class="bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-2">
          <strong class="text-gray-900 dark:text-white">Isto irá:</strong>
        </p>
        <ul class="space-y-1 text-sm text-gray-600 dark:text-gray-400">
          <li class="flex items-center gap-2">
            <lucide-icon name="check-circle" class="w-4 h-4 text-blue-500 flex-shrink-0"></lucide-icon>
            Redefinir o tema para <strong class="text-gray-900 dark:text-white">Claro</strong>
          </li>
          <li class="flex items-center gap-2">
            <lucide-icon name="check-circle" class="w-4 h-4 text-blue-500 flex-shrink-0"></lucide-icon>
            Remover todos os filtros de acessibilidade
          </li>
          <li class="flex items-center gap-2">
            <lucide-icon name="check-circle" class="w-4 h-4 text-blue-500 flex-shrink-0"></lucide-icon>
            Restaurar cores originais da aplicação
          </li>
        </ul>
      </div>
    </div>

    <!-- Footer com botões -->
    <div class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
      <button
        (click)="fecharConfirmacao()"
        class="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-900 dark:text-white font-medium rounded-lg transition-colors"
      >
        Cancelar
      </button>
      <button
        (click)="confirmarRestaurarPadroes()"
        class="px-6 py-2.5 bg-amber-600 hover:bg-amber-700 dark:bg-amber-500 dark:hover:bg-amber-600 text-white font-medium rounded-lg transition-colors shadow-sm"
      >
        Sim, Restaurar
      </button>
    </div>
  </div>
</div>
